@if (data().labelText) {
  <label class="text-xs" [for]="null">{{ data().labelText }}</label>
}
<div class="button-container flex justify-center">
  <button
    (click)="toggleSelectedValue(data().leftButton.value)"
    [class.selected]="selectedValue() === data().leftButton.value"
    [class.no-selected]="selectedValue() !== data().leftButton.value"
    data-testid="duo-selector-left-button"
  >
    {{ data().leftButton.text }}
  </button>
  <button
    (click)="toggleSelectedValue(data().rightButton.value)"
    [class.selected]="selectedValue() === data().rightButton.value"
    [class.no-selected]="selectedValue() !== data().rightButton.value"
    data-testid="duo-selector-right-button"
  >
    {{ data().rightButton.text }}
  </button>
</div>
